const DeviceType = {
  Hub: "Hub",
  IrrigationStation: "Irrigation Station",
  IrrigationController: "Irrigation Controller",
};

export default DeviceType;
